import _ from "lodash";
import moment from "moment";
import queryString from "query-string";
import { capitalize } from "shared/utils/string";

export const MENTION_REGEX = /<\|\d+\|>/g;
export const HASHTAG_REGEX = /<#\d+#>/g;
export const MENTION_OR_HASHTAG_REGEX = /(?:<\|\d+\|>)|(?:<#\d+#>)/g;

export const count = function(arr, attr) {
  if (!arr) { return 0; }

  let num = 0;
  arr.forEach(el => {
    if (el === attr) { num += 1; }
  });

  return num;
};

export const countArr = function(arr, attrs) {
  if (!arr || !attrs) { return 0; }

  let num = 0;

  attrs.forEach(attr => {
    num += count(arr, attr);
  });

  return num;
};

const WHITELISTED_STATE_SLICES = ["filters"];

export const loadState = () => {
  try {
    const serializedState = JSON.parse(localStorage.getItem("state"));
    const whitelistedState = {};

    WHITELISTED_STATE_SLICES.forEach(
      slice => (whitelistedState[slice] = serializedState[slice])
    );
    return whitelistedState;
  } catch (e) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (e) {
    return undefined;
  }
};

export const addLeadZero = (numberString) => {
  return numberString.length > 1 ? numberString : "0" + numberString;
};

// HH:MM:SS
export const formatDurationString = (durationStr, unit = "seconds") => {
  const dur = moment.duration(durationStr, unit);
  const seconds = dur.seconds().toString();
  const minutes = dur.minutes().toString();
  const hours = dur.hours().toString();
  return (
    (hours === "0" ? "" : hours + ":") +
    (hours === "0" ? minutes : addLeadZero(minutes)) + ":" +
    addLeadZero(seconds)
  );
};

export const formatDateTime = dateTime => {
  return moment(dateTime).format("MMM Do h:mm A");
};

export const formatTime = dateTime => {
  return moment(dateTime).format("h:mm A");
};

export const formatShortName = (user) => {
  return user.first_name + " " + user.last_name.substring(0, 1);
};

export const formatDuration = seconds => {
  let date = new Date(null);
  date.setSeconds(seconds);
  date = date.toISOString().substr(11, 8);
  return date.replace(/^00:/, "").replace(/^0/, ""); // remove leading zeros
};

// This should probably be done in the be
export function setCallEventsWidth(events) {
  const callEvents = events.slice();
  const lastTime = callEvents[callEvents.length - 1]["end_time"];

  if (lastTime) {
    callEvents.forEach((event, i) => {
      const left = 100 * (event["start_time"] / lastTime);
      const width =
        100 * ((event["end_time"] - event["start_time"]) / lastTime);
      callEvents[i].left = left;
      callEvents[i].width = width;
    });
  } else {
    // Some calls lack timestamp so we go by content length instead
    let sumLength = 0;
    callEvents.forEach((event, i) => {
      callEvents[i].contentBefore = sumLength;
      sumLength += event.content.length;
    });
    callEvents.forEach((event, i) => {
      const left = 100 * (event.contentBefore / sumLength);
      const width = 100 * (event.content.length / sumLength);
      callEvents[i].left = left;
      callEvents[i].width = width;
    });
  }
}

export function titleize(string) {
  if (string === undefined || string === null) {
    return "";
  }
  return capitalize(string);
}

export function percentage(num1, num2) {
  if (num1 == 0 || num2 == 0) {
    return (0).toFixed(1);
  }
  return (num1 / num2 * 100).toFixed(1);
}

export function possessive(str) {
  return str.slice(-1) === "s" ? str + "'" : str + "'s";
}

export function pluralize(str, num = 2) {
  return num == 1 ? str : str + "s";
}

// TODO: This is gross
export function processCallEvents(call) {
  if (call.events) {
    // Hide blacklisted skills
    call.events = call.events.map(e => ({
      ...e,
      skill_ids: e.skill_ids,
    }));
    // This probably should be done on the BE
    setCallEventsWidth(call.events);
  }
}

// $component   - component that will be scrolled
// scrollTo     - pixel height to scroll to
// scrollHeight - (ratio) how far down the page scrollTo should appear
export const scrollComponent = ($component, scrollTo, scrollHeight = 0.0) => {
  const scrollBuffer = $component.clientHeight * scrollHeight;
  $component.scrollTop = scrollTo - scrollBuffer;
};

export const CATEGORIES_ORDER_MAP = {
  "surface_discovery": 0,
  "deep_discovery": 10,
  "pitch": 20,
  "objection": 30,
  "best_price_guarantee": 35,
  "close_attempt": 40,
  "setting_expectations_support": 50,
  "clarifies_issue_support": 60,
};

export const hashtagify = (string) => {
  if (!string) { return ""; }
  return `#${string.split(" ").filter(str => str !== "").map(word => `${word[0].toUpperCase()}${word.slice(1)}`).join("")}`;
};

export const RE_SPECIAL_CHAR = /\[|\^|\$|\.|\|\\|\?|\*|\+|\(|\)/;

export const getAllRegExpMatches = (string, regex) => {
  const matches = [];
  for(let match = regex.exec(string); match !== null; match = regex.exec(string)) {
    matches.push(match[1]);
  }
  return matches;
};

export const FAQ_DOCUMENT_URL = 'https://docs.google.com/document/d/e/2PACX-1vSqzxJVhEA4ORWrT89EWCU_UZAC5-ZaoqtayVYv5rvF6L0Hw44XGZglwShQpxCuHZqY0oQbjGX0he_X/pub';
